export const routeConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL
};